export default [
  {
    title: 'scrivania',
    route: 'rubisco-dashboard',
    icon: 'HomeIcon',
    action: 'read',
    resource: 'ACL',
  },
]
